<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 18 18"
       role="presentation"
       @click="$emit('click')">
    <g :fill="disabled ? disabledStateColor : iconColor">
      <path d="M13.3218644,7.76591678 L10.2340832,4.67813557 L2,12.9122188 L2,16 L5.08778121,16 L13.3218644,7.76591678 Z M15.7591531,5.32862814 C16.0802823,5.0074989 16.0802823,4.48875165 15.7591531,4.16762241 L13.8323776,2.24084693 C13.5112483,1.91971769 12.9925011,1.91971769 12.6713719,2.24084693 L11.0574915,3.85472725 L14.1452728,6.94250845 L15.7591531,5.32862814 Z"></path>
    </g>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>
